import { combineReducers } from "redux";

import InfathParticipationWorkflowReducer from "./auctions/infathParticipationWorkflow/reducer";
import auction from "./auctions/reducer";
import SellerSpecialEligibilityReducer from "./auctions/sellerSpecialEligibility/reducer";
import auth from "./auth/reducer";
import filters from "./filters/reducer";
import menu from "./menu/reducer";
import settings from "./settings/reducer";

const reducers = combineReducers({
  menu,
  settings,
  auction,
  auth,
  filters,
  InfathParticipationWorkflowReducer,
  SellerSpecialEligibilityReducer,
});

export default reducers;
